<div class="row align-items-center">
  @if (direction === 'buy') {
    <div class="col text-left">
      <trade-create-buying-power
        data-zid="buying-power"
        [buyingPowerDetails]="facade.buyingPower$ | async"
        [isBuyingPowerTooLow]="facade.hasNotEnoughBuyingPower$ | async"
        [isLeftAligned]="true"
      />
    </div>
    <div class="col text-right" [class.text-color-error]="facade.hasNotEnoughBuyingPower$ | async">
      <div>{{ 'trade.multi-order.create.buy.sum' | transloco }}</div>
      <div class="estimated-sum" data-zid="estimated-buy-sum">
        @if ((facade.validForm$ | async) && (facade.estimatedBuySum$ | async)) {
          {{ facade.estimatedBuySum$ | async | currency }}
        } @else {
          &mdash;
        }
      </div>
    </div>
  } @else {
    <div class="col text-right">
      <div>{{ 'trade.multi-order.create.sell.sum' | transloco }}</div>
      <div class="estimated-sum" data-zid="estimated-sell-sum">
        @if ((facade.validForm$ | async) && (facade.estimatedSellSum$ | async)) {
          {{ facade.estimatedSellSum$ | async | currency }}
        } @else {
          &mdash;
        }
      </div>
    </div>
  }
</div>
